
 <template >
   <div class="div">
  <section >




    <v-container grid-list-md>
      <form enctype="multipart/form-data">
               <p class="p-titulo display-1  "><strong>Editar Perfil</strong></p>
        <v-layout row wrap>
          <v-flex xs4 sm4 md4 offset-xs1 class="izquierda">
              <div class="foto-perfil">
                <v-flex
                xs12
                sm6
                md8
                text-xs-center
                layout
                align-center
                justify-center
              >
                <v-avatar

                  size="120px"
                  class="grey lighten-4"
                >
                  <img :src="usuario.avatar"/>
                </v-avatar>
              </v-flex>
              <v-flex
                xs12
                sm6
                md8
                text-xs-center
                layout
                align-center
                justify-center
              >
                 <input class="btn-img" type="file" accept="image/*;capture=camera" @change="procesarArchivo($event)">
              </v-flex>
              <v-btn color="accent white--text" @click="enviarImagen()">Guardar Imagen</v-btn>
              </div>

          </v-flex>

          <v-flex class="derecha" xs6 sm6 md6  offset-xs1>
            <p class=" display-1  "><strong>Tus Datos</strong></p>
            <v-layout row wrap>

              <v-flex xs4 sm4>
                <v-text-field  label="Nombres" v-model="usuario.nombre"></v-text-field>
              </v-flex>
              <v-flex xs4 sm4>
                <v-text-field  label="Apellidos" v-model="usuario.apellido"></v-text-field>
              </v-flex>
              <v-flex xs4></v-flex>
              <v-flex xs8>
                <v-text-field

                label="Email"
                v-model="usuario.email"
                hint="Ingresa tu email!"
                persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs4></v-flex>


            <v-flex xs8 sm8>
              <v-text-field

              label="Rut"
              v-model="usuario.rut"
              hint="Ingresa tu rut"
              persistent-hint
              ></v-text-field>
            </v-flex>

<!--                  <v-flex xs8>
              <v-text-field

              name="input-10-1"
              label="Ingresa tu nueva Contraseña"
              hint="Minimo 8 caracteres"
              v-model="usuario.password"
              min="8"
              :append-icon="e1 ? 'visibility' : 'visibility_off'"
              :type="e1 ? 'password' : 'text'"
              counter
              ></v-text-field>
            </v-flex> -->
            <v-flex xs4></v-flex>
            <v-flex xs3>
             <v-btn
             block dark color="primary" raised
             @click="submitUser(usuario)"
             :disabled="!valid"
             >
             Guardar Cambios
           </v-btn>
           
         </v-flex>
   <!--       <v-flex xs3>
           <v-btn @click="">cancelar</v-btn>
         </v-flex> -->
            </v-layout>
          </v-flex>


     </v-layout>
   </form>
 </v-container >

  <v-snackbar
      :timeout="timeout"
      :color="colorSnackbar"
      v-model="snackbar"
    >
    <v-icon dark>check_circle</v-icon>
      {{ textSnackbar }}
      <v-btn dark flat @click.native="snackbar = false">X</v-btn>
  </v-snackbar>

</section>
</div>
</template>

<script>
import { updateBasicService } from '@/services/Usuario/UpdateBasic.service'
import { getUser } from '@/services/GetUser.service'
import { updateAvatarService } from '@/services/Usuario/UpdateAvatar.service'
export default {
  data () {
    return {
      e1: false,
      valid: true,
      usuario: {},
      fileUploaded: {},
      dialogArchivo: false,
      archivo: {},
      snackbar: false,
      colorSnackbar: '',
      timeout: 6000,
      textSnackbar: '',
      user: {
        usuario_nombre: '',
        usuario_apellido: '',
        usuario_rut: '',
        usuario_email: ''
      }
    }
  },
  methods: {
    submitUser (model) {
      let vm = this
      vm.user.usuario_nombre = model.nombre
      vm.user.usuario_apellido = model.apellido
      vm.user.usuario_rut = model.rut
      vm.user.usuario_email = model.email
      updateBasicService.update(vm.usuario.id, vm.user).then(data => {
        vm.mensajeToast('success', true, 'Perfil editado con éxito')
        vm.usuario = data.body
      }, response => {
        vm.mensajeToast('error', true, 'Error al editar Perfil')
      })
    },
    clear () {
      this.$refs.form.reset()
    },
    enviarImagen () {
      var vm = this
      var formData = new FormData()
      formData.append('file', vm.archivo.file)
      updateAvatarService.save(formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(data => {
        vm.usuario = data.body
      // this.$router.push({name: 'editCource', params: {id: data.body.id}})
      }, response => {
      })
    },
    loadUsuario () {
      let vm = this
      getUser.query().then(data => {
        vm.usuario = data.body
      })
    },
    procesarArchivo (event) {
      var vm = this
      vm.archivo.file = event.target.files[0]
    },
    mensajeToast (color, snack, texto) {
      let vm = this
      vm.colorSnackbar = color
      vm.snackbar = snack
      vm.textSnackbar = texto
    }
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    }
  },
  mounted () {
    this.loadUsuario()
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.btn-img{
    margin-top: 20px
}
.foto-perfil {
  margin-top: 50px;

}

.p-titulo  {
color: #1976d2;
 
margin: 50px;

}

.izquierda {
 border-right: 1px solid #369;
}
</style>




// WEBPACK FOOTER //
// src/components/Usuario/EditUsuario.vue